/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_ImageInputs */

const en_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Image`)
};

const es_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen del anuncio`)
};

const fr_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image de l'annonce`)
};

const de_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat-Bild`)
};

const ja_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品画像`)
};

const zh_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品图片`)
};

const ar_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صورة الإعلان`)
};

const id_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambar Listing`)
};

const it_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immagine Annuncio`)
};

const ru_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изображение объявления`)
};

const pt_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagem do Anúncio`)
};

const ko_listing_image = /** @type {(inputs: Listing_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 이미지`)
};

/**
* | output |
* | --- |
* | "Listing Image" |
*
* @param {Listing_ImageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_image = /** @type {((inputs?: Listing_ImageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_ImageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_image(inputs)
	if (locale === "es") return es_listing_image(inputs)
	if (locale === "fr") return fr_listing_image(inputs)
	if (locale === "de") return de_listing_image(inputs)
	if (locale === "ja") return ja_listing_image(inputs)
	if (locale === "zh") return zh_listing_image(inputs)
	if (locale === "ar") return ar_listing_image(inputs)
	if (locale === "id") return id_listing_image(inputs)
	if (locale === "it") return it_listing_image(inputs)
	if (locale === "ru") return ru_listing_image(inputs)
	if (locale === "pt") return pt_listing_image(inputs)
	return ko_listing_image(inputs)
});